var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('a-icon',{attrs:{"type":"search"}}),_c('Input',{staticClass:"search",attrs:{"placeholder":_vm.$t('Pretražite projekte'),"allowClear":"","data-test":"search"},on:{"pressEnter":_vm.onSearch},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }